export class VideoFrameSelectorService {
  static captureFrameFromVideo(
    video: HTMLVideoElement,
    targetTime: number,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Unable to get canvas context'));
        return;
      }

      const handleSeeked = () => {
        try {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          const frameDataUrl = canvas.toDataURL('image/jpeg', 0.8);
          resolve(frameDataUrl);
        } catch (error) {
          reject(error);
        } finally {
          video.removeEventListener('seeked', handleSeeked);
        }
      };

      const handleError = (error: Event) => {
        video.removeEventListener('error', handleError);
        reject(new Error('Error seeking video'));
      };

      video.addEventListener('seeked', handleSeeked, {once: true});
      video.addEventListener('error', handleError, {once: true});

      video.currentTime = targetTime;
    });
  }

  static convertDataUrlToBlob(dataUrl: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      try {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/jpeg';
        const bstr = atob(arr[1]);
        const n = bstr.length;
        const u8arr = new Uint8Array(n);

        for (let i = 0; i < n; i++) {
          u8arr[i] = bstr.charCodeAt(i);
        }

        resolve(new Blob([u8arr], {type: mime}));
      } catch (error) {
        reject(error);
      }
    });
  }

  static formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  static generateFrameFileName(
    originalVideoName: string,
    timeStamp: number,
  ): string {
    const baseName = originalVideoName.replace(/\.[^/.]+$/, '');
    const timeFormatted = this.formatTime(timeStamp).replace(':', 'm') + 's';
    return `${baseName}_frame_${timeFormatted}.jpg`;
  }
}
